export enum ApiFieldListShowType {
  Text = 'text',
  Link = 'link',
  Tag = 'tag',
  Tooltip = 'tooltip',
  Date = 'date',
  UpdatedAt = 'updatedAt',
}

export type ApiFieldList =
  | {
      type: ApiFieldListShowType.Text;
      key: string;
      name: string;
      value: string;
      hidden: boolean;
    }
  | {
      type: ApiFieldListShowType.Date;
      key: string;
      name: string;
      value: string;
      hidden: boolean;
    }
  | {
      type: ApiFieldListShowType.UpdatedAt;
      key: string;
      name: string;
      format: string;
      value: string;
      hidden: boolean;
    }
  | {
      type: ApiFieldListShowType.Link;
      key: string;
      name: string;
      value: string;
      hidden: boolean;
    }
  | {
      type: ApiFieldListShowType.Tag;
      key: string;
      name: string;
      value: string[];
      hidden: boolean;
    }
  | {
      type: ApiFieldListShowType.Tooltip;
      key: string;
      name: string;
      value: string;
      tooltip: string;
      hidden: boolean;
    };
